export default __webpack_public_path__ + "static/media/layers-icon.c2f8317e.svg";